import { Box, Modal, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { getCityFromLatLng, getLocationFromLatLng } from '../../../utils/Parser';
import { GetRfidDetails } from '../../../network/Devices';

const DetailText = styled('span')({
  fontSize: '16px',
  fontWeight: 600
});
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  minWidth: { xs: '70%', md: '40%' },
  maxWidth: { xs: '70%', md: '40%' },
  p: 2,
  borderRadius: 1
};

export default function DeviceRfidModal({
  openAssignedModal,
  handleClose,
  deviceId,
  selectedRfidData
}) {
  const [rfidData, setRfidData] = useState(null);
  const [city, setCity] = useState('');

  const getChannelName = (channel) => {
    switch (channel) {
      case 'RFID':
        return 'RFID';
      case 'MQTT':
        return 'DASHBOARD';
      // case 'SMS':
      //   return 'SMS';
      default:
        return '';
    }
  };

  const getRfidDetail = async (deviceId, requestId, selectedChannel) => {
    let type = '';
    if (selectedChannel?.channel === 'RFID') {
      type = 'card';
    } else if (selectedChannel?.channel === 'MQTT') {
      type = 'web';
    }

    if (!type) {
      console.error('Invalid selectedChannel value:', selectedChannel);
      return;
    }

    try {
      const res = await GetRfidDetails(deviceId, requestId, selectedChannel);
      if (res) {
        setRfidData(res?.data?.data);
      }
    } catch (error) {
      console.log(error, 'err');
    }
  };

  useEffect(() => {
    getRfidDetail(deviceId, selectedRfidData?.request_id, selectedRfidData);
  }, []);

  useEffect(() => {
    if (selectedRfidData?.location_lat && selectedRfidData?.location_lng) {
      getLocationFromLatLng(selectedRfidData?.location_lat, selectedRfidData?.location_lng)
        .then((result) => {
          setCity(result); // Update city once resolved
        })
        .catch((error) => {
          console.error('Error fetching city:', error);
          setCity('Unknown Location');
        });
    }
  }, [selectedRfidData, getCityFromLatLng]);

  return (
    <Modal
      open={openAssignedModal}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      data-testid="unlock-channel-modal"
      BackdropProps={{ 'data-testid': 'modal-backdrop' }}
    >
      <Box sx={style}>
        <Typography sx={{ fontSize: 18, fontWeight: 900, mb: 2 }}>Device Unlock Details</Typography>
        <Box>
          <Typography sx={{ fontSize: 14, lineHeight: '24px', fontWeight: 500 }}>
            The lock was opened via{' '}
            <DetailText>{getChannelName(selectedRfidData?.channel)}</DetailText> by{' '}
            <DetailText>{rfidData?.name}</DetailText> (<DetailText>{rfidData?.detail}</DetailText>)
            on{' '}
            <DetailText>
              {moment(parseInt(selectedRfidData?.timestamp, 10)).format('DD/MM/YYYY')}
            </DetailText>{' '}
            at{' '}
            <DetailText>
              {moment(parseInt(selectedRfidData?.timestamp, 10)).format('hh:mm A')}
            </DetailText>
            , at the location <DetailText>{city}</DetailText>, with the lock's battery at{' '}
            <DetailText>{selectedRfidData?.battery_remaining}%</DetailText>.
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
}
